module.exports = __webpack_public_path__ + "LimitedMobility-1VOt2WI.svg";